import { useCallback, useEffect } from 'react';

export default function useSearch(setSearchQuery: (searchQuery: TSearchQuery) => void) {
  const handleSearchEvent = useCallback(
    (event: any) => {
      event.preventDefault();

      const {
        detail: { category: categoryId, distance, postcode, query },
      } = event;

      setSearchQuery({ query, postcode: postcode?.trim(), radius: Number(distance), categoryId: Number(categoryId) });
    },
    [setSearchQuery],
  );

  useEffect(() => {
    document.addEventListener('search', handleSearchEvent);

    return () => document.removeEventListener('search', handleSearchEvent);
  }, [handleSearchEvent]);
}
